import { render, staticRenderFns } from "./modalCadastro.vue?vue&type=template&id=bc74749e&scoped=true"
import script from "./modalCadastro.vue?vue&type=script&lang=js"
export * from "./modalCadastro.vue?vue&type=script&lang=js"
import style0 from "./modalCadastro.vue?vue&type=style&index=0&id=bc74749e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bc74749e",
  null
  
)

export default component.exports